import Cookies from 'js-cookie'

export const DEMO_SESSION_COOKIE = 'navigatorDemoSession'
export const DEMO_HINT_COOKIE = 'navigatorDemo'

// This cookie is a UI hint. Authentication is always checked on the server.
export const isDemoSession = () => Cookies.get(DEMO_HINT_COOKIE) === '1'
export const hasClientSession = () =>
  Boolean(Cookies.get('accessToken') || isDemoSession())

export const csrfHeader = () => ({
  'X-CSRFToken':
    Cookies.get('navigatorDemoCsrf') || Cookies.get('csrftoken') || '',
})
